import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const PluginsEngine = styled.div`
  position: 'absolute';
  top: 0;
  left: 0;
  width: '100vw';
  height: '100vh';
  z-index: -1;
`;
